import { createIconTableObj } from "./create_icon_table_obj";
import {checkIfPurchaseAHomeIcon} from "./check_if_purchase_a_home_icon";
import protectPlanCondNames from "../datasets/protect_plan_condNames";

export const checkIconTableEntries = (iconTable, currentCash, savingsInfo, monthlyIncome,
        moodPoints, pendingJob, creditCardInfo, conditionsTable, gameNbrMonths, 
        unlockedFeatures, rentExpense, moneyMgmtTest, totalNbrGameMonths, investPayoutValid) => {
       
    let newIconTable = JSON.parse(JSON.stringify( [iconTable[0]]));
   
    if (investPayoutValid === true){
        const iconTableObj = iconTable.find(elem => elem.iconName === "investPayout");
        if (iconTableObj){
            newIconTable.push(iconTableObj);
        }
    }
        
    //  1.  send current iconTable to 'createIconTableObj' if additionalInfo, then update to have new additionalInfo
    //      if no additionalInfo, and icon already there, then copy from current to new.
    if (currentCash < 0){
        let cashCheckAmt = -1 * currentCash;
        if (savingsInfo.totalSavingsAmt  &&
            savingsInfo.totalSavingsAmt > cashCheckAmt){
                newIconTable = createIconTableObj("savingsTransfer", newIconTable, "", iconTable);            
        }else{  
                newIconTable = createIconTableObj("negativeCash", newIconTable, "", iconTable);
        }
    }else{
        if (monthlyIncome < 0){
            newIconTable = createIconTableObj("negativeNetIncome", newIconTable, "", iconTable);
        }
    }

    if (moodPoints < 0){
            newIconTable = createIconTableObj("negativeMoodPoints", newIconTable, "", iconTable);
    }
    
    if (pendingJob  && 
        Object.keys(pendingJob).length !== 0){
          //  let pendingJobIcon = iconTable.find(elem => elem.iconName === "pendingJob");
            newIconTable = createIconTableObj("pendingJob", newIconTable, "", iconTable);
    }

    let monthlySavingsAmt = 0;
    if (savingsInfo.gameID){
        for (let i=0; i<savingsInfo.savingsArr.length; i++){        
            const savingsObj = savingsInfo.savingsArr[i];
            if (savingsObj.closedDate === ""){
                monthlySavingsAmt += +savingsObj.monthlyDepositAmt;
            }
        }
        if (monthlySavingsAmt > +monthlyIncome){
            newIconTable = createIconTableObj("savingsGTIncome", newIconTable, "", iconTable);
        }
    }

    if (creditCardInfo.gameID){
        if ( +creditCardInfo.totalOutstandingBalance >= +creditCardInfo.creditMaxAmount){
            newIconTable = createIconTableObj("creditLimitExceeded", newIconTable, "", iconTable);
        }else{
            if (+currentCash <= +creditCardInfo.totalOutstandingBalance &&
                creditCardInfo.paymentPolicyCode === "autoPayFull"){
                newIconTable = createIconTableObj("insufficientCash", newIconTable, "", iconTable);
            }
        }
    }
   
    if (rentExpense ){
        let purchaseAHome = checkIfPurchaseAHomeIcon(conditionsTable,
            gameNbrMonths, currentCash, monthlyIncome, rentExpense,
            totalNbrGameMonths);
        if (purchaseAHome === true){
            newIconTable = createIconTableObj("purchaseAHome", newIconTable, "", iconTable);
        }
    }

    const iconConditions = conditionsTable.filter(elem => elem.iconName && elem.iconName !== "");
    for (let i=0; i<iconConditions.length; i++){
        const iconName = iconConditions[i].iconName;
        newIconTable = createIconTableObj(iconName, newIconTable, "additionalInfo", iconTable);
    }

    if (moneyMgmtTest === false){
        const iconName = "takeMoneyMgmtTest";
        newIconTable = createIconTableObj(iconName, newIconTable, "", iconTable);
    }
 
    // check unlocked features table create iconTable if unlocked feature has not been activated
    for (let i=0; i<unlockedFeatures.length; i++){
        let iconName = "";
        iconName = unlockedFeatures[i].featureName;
        const additionalInfo = {unlockedFeature: true, level: unlockedFeatures[i].level};
        if (unlockedFeatures[i].setup === "none"){
            // if icon is already in the icontable, then just add it back to the table
            newIconTable = createIconTableObj(iconName, newIconTable, additionalInfo, iconTable);
        }
    }

    return newIconTable;

}
export default checkIconTableEntries;





